import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { AppsRatingFilterDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsRatingFilter } from "app/pages/sales-intelligence/store/find-apps/types";

type IAppsRatingFilterOptions = readonly number[];

export default class FindAppsRatingFilter
    extends FilterPanelBaseFilter<IAppsRatingFilter, AppsRatingFilterDescriptionDto>
    implements IFilterPanelBaseFilterModel<IAppsRatingFilter, AppsRatingFilterDescriptionDto>
{
    readonly minOptions: IAppsRatingFilterOptions;
    readonly maxOptions: IAppsRatingFilterOptions;
    readonly scoreOptions: IAppsRatingFilterOptions;

    constructor(deps: IFilterPanelBaseFilterDeps<IAppsRatingFilter, AppsRatingFilterDescriptionDto>) {
        super(deps);

        const {
            options: { numberOfRatingsBuckets },
        } = deps;

        this.minOptions = numberOfRatingsBuckets.slice(0, numberOfRatingsBuckets.length - 1);
        this.maxOptions = numberOfRatingsBuckets.slice(1);

        this.scoreOptions = Array.from({ length: 6 }, (_, i) => i).reverse();
    }

    isFilterDirty(currentValue: IAppsRatingFilter | undefined): boolean {
        const { score: initScore, ...initNumberOfRatings } = this.initialDtoValue ?? {};
        const { score, ...numberOfRatings } = currentValue ?? {};

        return (
            JSON.stringify(initScore ?? []) !== JSON.stringify(score ?? []) ||
            JSON.stringify(initNumberOfRatings) !== JSON.stringify(numberOfRatings)
        );
    }
}
